module.exports = __webpack_public_path__ + "img/1080_02.c153161c.jpg";